import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { ConfigProvider } from '../../providers/config/config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'pill-slider-sub-menu',
  templateUrl: 'pill-slider-sub-menu.html',
})
export class PillSliderSubMenuComponent {
  log = debug('app:PillSliderSubMenuComponent');

  @ViewChild('component') PillSliderSubMenuComponent;

  @Output() feedChange = new EventEmitter();

  @Input() feedOptions = [];

  @Input() forceShow: boolean = false;
  @Input() selectedFeedIndex: number | null = null;

  showPills = true;

  constructor(
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public configs: ConfigProvider
  ) {}

  ngOnInit() {
    const config = this.configs.get('home-pills-menu');
    this.log('config', !!config);
    this.showPills = this.forceShow || !!config;
  }

  toggleSubFeedMenu(feed, index) {
    this.feedChange.emit(feed);
  }
}



// WEBPACK FOOTER //
// ./src/components/pill-slider-sub-menu/pill-slider-sub-menu.ts